import { ENV } from '@/env';

declare global {
  interface Window {
    pendo: any;
  }
}

type PendoVisitor = {
  id: string;
  name: string;
  email: string;
};

export type PendoConfig = {
  visitor: PendoVisitor;
  account?: unknown;
};

export function initializePendo(visitor: PendoConfig['visitor'], account?: PendoConfig['account']) {
  if (!window.pendo || ENV !== 'production') {
    return;
  }

  window.pendo.initialize({ account, visitor });
}
